/**
 * EQ-004 (D-10, D-221) - POST /engagements for a second hour bank is refused with 409
 * HOUR_BANK_ALREADY_ACTIVE + the existing bank's engagement id. Pure helper: reads that out of
 * whatever shape the api layer rejects with (the body `{ error }` or an axios error).
 */
export const HOUR_BANK_ALREADY_ACTIVE = 'HOUR_BANK_ALREADY_ACTIVE';

export function activeHourBankOf(err: unknown): { engagementId: string; name: string | null } | null {
  const o = err as { error?: unknown; response?: { data?: { error?: unknown } } } | null;
  const e = (o?.error ?? o?.response?.data?.error) as
    { error_code?: string; details?: { existing_engagement_id?: string; existing_bank_name?: string } } | undefined;
  if (e?.error_code !== HOUR_BANK_ALREADY_ACTIVE || !e.details?.existing_engagement_id) return null;
  return { engagementId: e.details.existing_engagement_id, name: e.details.existing_bank_name ?? null };
}
